import { useConfig } from "$global-providers/config-provider/provider";
import { TERRITORY } from "$routes/_lib/constants";

const currencyMap = {
  [TERRITORY.NIGERIA]: {
    format: {
      compact: false,
      locale: "en-NG",
    },
    decimal: 2,
    code: "NGN",
    uuid: "6ae235f2-e345-404a-aab4-4e43f4faac5f",
  },

  [TERRITORY.KENYA]: {
    decimal: 2,
    code: "KES",
    format: {
      compact: true,
      locale: "en-KE",
    },
    uuid: "6d300ea6-8421-4678-88ad-7c33a71bb877",
  },

  [TERRITORY.PAKISTAN]: {
    decimal: 2,
    format: {
      compact: false,
      locale: "en-PK",
    },
    code: "PKR",
    uuid: "d38472d2-02e8-437a-b55a-565e19516c8a",
  },

  [TERRITORY.LIBERIA]: {
    decimal: 2,
    format: {
      compact: false,
      locale: "en-LR",
    },
    code: "USD",
    uuid: "2aada823-6a68-4a43-b073-097fd5b8a9e8",
  },
};

export function useCurrency() {
  const { territory } = useConfig();

  if (!territory) {
    return undefined;
  }

  return currencyMap[territory];
}
